import {NgModule} from '@angular/core';
import {ArticleBlockImageComponent} from './article-block-image.component';
import {PremiumOverlayModule} from '@tisa-group/client-ui/components/premium-overlay';
import {CommonModule} from '@angular/common';
import {ImageModule} from '@tisa-group/client-ui/components/image';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [ArticleBlockImageComponent],
  exports: [ArticleBlockImageComponent],
  imports: [CommonModule, PremiumOverlayModule, ImageModule, RouterModule],
})
export class ArticleBlockImageModule {}
